import React from 'react';

import { Button } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * A RenderContent component for a Toast which informs the user they are trying to turn off
 * detection for a track before a full quarter of detection has elapsed.
 * @param props {ToastRenderContentProps<{}>}
 */
export const GapAnalysisUnavailable = ({
    remove,
}: ToastRenderContentProps<Record<string, never>>): JSX.Element => (
        <div style={{ width: 350 }} className="px-2 text-sm">
            <div className="font-bold text-highlight-orange tracking-wider">
                {
                    locale.enUS.MANAGE_DETECTIONS.TOASTS
                        .GAP_ANALYSIS_UNAVAILABLE.TITLE
                }
            </div>
            <div className="mt-4 mb-8">
                {
                    locale.enUS.MANAGE_DETECTIONS.TOASTS
                        .GAP_ANALYSIS_UNAVAILABLE.DESCRIPTION
                }
            </div>
            <div className="flex justify-end">
                <Button
                    addClasses="mr-4"
                    color="danger-secondary-light-bg"
                    autoWidth={true}
                    handleClick={(): void => {
                        remove({
                            canceled: true,
                            success: false,
                        });
                    }}
                >
                    <div className="mx-4">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .GAP_ANALYSIS_UNAVAILABLE.BUTTONS.MAKE_CHANGES
                        }
                    </div>
                </Button>
                <Button
                    color="danger-primary-light-bg"
                    autoWidth={true}
                    handleClick={(): void => {
                        remove({
                            canceled: false,
                            success: true,
                        });
                    }}
                >
                    <div className="mx-4">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .GAP_ANALYSIS_UNAVAILABLE.BUTTONS.APPLY_ANYWAY
                        }
                    </div>
                </Button>
            </div>
        </div>
    );
